import { deepCopy } from '../utils';

/**
 * Offline operation config for the manualRestock mutation (markets and
 * comm-failure fallbacks). The server mutation is a no-op when the docket is
 * already restocked (e.g. a fill DEX arrived while this sat in the queue), so
 * replay is safe. The optimistic update advances the guided board to the
 * confirm step; the docket completes server-side when the queue syncs.
 */
const manualRestockConfig = {
	serializeVariables: ({ variables }) => deepCopy({
		...variables,
		queuedOffline: true,
	}),
	createMeta: ({ variables, context = {} }) => {
		const offlineMeta = context.offlineMeta || {};

		return {
			serviceDocketId: variables?.serviceDocketId,
			type: 'manualRestock',
			machine: offlineMeta.machineDetails || null,
			machineId: offlineMeta.machineId || null,
			fallbackMachineName: offlineMeta.machineName || null,
		};
	},
	applyOptimisticUpdate: async ({ client, variables }) => {
		const cacheId = client.cache.identify({
			__typename: 'ServiceDocket',
			id: variables.serviceDocketId,
		});

		if (!cacheId) {
			return;
		}

		client.cache.modify({
			id: cacheId,
			fields: {
				isRestocked: () => true,
				startedProcessing: () => true,
				manualRestock: () => true,
			},
		});
	},
	getOfflineResult: ({ variables, queueEntry }) => ({
		manualRestock: {
			__typename: 'ServiceDocket',
			id: variables.serviceDocketId,
			isRestocked: true,
			startedProcessing: true,
			offlineQueuedAt: queueEntry.createdAt,
			machine: queueEntry.meta?.machine || null,
			offline: true,
		},
	}),
};

export default manualRestockConfig;
